import baseFetch, { createParamString } from '../baseFetch';

export interface FetchLocationViewTravelOptions {
  preview?: boolean;
}

export const fetchLocationViewTravel = async (
  geonameId: string | string[] | undefined,
  cookies?: Record<string, unknown>,
  options: FetchLocationViewTravelOptions = {},
) => {
  const { preview } = options;
  const params: Record<string, string> = { type: 'travel', id: String(geonameId) };
  if (preview) params.preview = 'true';
  const query = createParamString(params);
  return baseFetch(`/location/view?${query}`, { cookies });
};

export const fetchLocationViewWorld = (cookies?: Record<string, unknown>) =>
  baseFetch('/location/view/worldtaxonomy?', { cookies });
